import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { t } from '../../../../../i18n';
import { DownloadIconComponent } from '../../../../assets';
import './styles.scss';

const DownloadMaterialsButton = ({ materials }) => {
  return (
    <Dropdown className="courses-watch-lesson__download-materials">
      <Dropdown.Toggle className="courses-watch-lesson__download-materials__button">
        <DownloadIconComponent />
        <span>{t('DIGITAL_COURSES.WATCH.DOWNLOAD_MATERIALS')}</span>
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {materials.map(m => (
          <a
            key={m.fileUrl}
            href={m.fileUrl}
            download={m.fileUrl.split('/').pop()}
            className="courses-watch-lesson__download-materials__material"
            target="_blank"
            rel="noopener noreferrer"
          >
            {m.name}
          </a>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default DownloadMaterialsButton;
